import * as React from 'react';
import {Dropdown} from 'react-bootstrap';
import {PowerMode} from '../../Settings/settings';

interface PowerModeDropdownProps {
    powerMode: PowerMode;
    setPowerMode: (mode: PowerMode) => void;
}

export const PowerModeDropdown: React.FC<PowerModeDropdownProps> = ({ powerMode, setPowerMode }) => {
    const handlePowerModeChange = (mode: PowerMode) => {
        setPowerMode(mode);
    };

    return (
        <Dropdown className="dropdown p-2" autoClose="outside">
            <Dropdown.Toggle
                className="btn btn-secondary btn-sm dropdown-toggle"
                type="button"
                id="dropdown-autoclose-outside"
                data-bs-toggle="dropdown"
                aria-expanded="false"
            >
                Settings
            </Dropdown.Toggle>
            <Dropdown.Menu aria-labelledby="settingsDropdown">
                <li><h6 className="dropdown-header">Power</h6></li>
                <li>
                    <label className="dropdown-item">
                        <input
                            type="radio"
                            name="powerMode"
                            value="RP3 Power"
                            checked={powerMode === PowerMode.RP3}
                            onChange={() => handlePowerModeChange(PowerMode.RP3)}
                        /> RP3 Power
                    </label>
                </li>
                <li>
                    <label className="dropdown-item">
                        <input
                            type="radio"
                            name="powerMode"
                            value="Split Power"
                            checked={powerMode === PowerMode.Split}
                            onChange={() => handlePowerModeChange(PowerMode.Split)}
                        /> Split Power
                    </label>
                </li>
            </Dropdown.Menu>
        </Dropdown>
    );
};